import React from "react";
import { NavLink } from "react-router-dom";
import { StyledNavbar, StyledList } from "./navbar.style";

// TODO make navbar sticky
const Navbar = () => {
  return (
    <StyledNavbar>
      <StyledList>
        <li key="dashboard">
          <NavLink to="/dashboard" replace>Dashboard</NavLink>
        </li>
        <li key="plans">
          <NavLink to="/plans">Plans</NavLink>
        </li>
        <li key="setup">
          <NavLink to="/setup">Settings</NavLink>
        </li>
        <li key="support">
          <NavLink to="/support">Support</NavLink>
        </li>
      </StyledList>
    </StyledNavbar>
  );
};
export default Navbar;
